// ═══════════════════════════════════════════════════════════════
// V·IANet Governance — References Tab
// ═══════════════════════════════════════════════════════════════

import { Link } from 'react-router-dom';
import { C } from '../../../../../lib/design';
import { DOC_COLORS } from '../../../../../config/documentStyles';
import { Ic, ICON_PATHS } from '../../../../../lib/ui';
import type { ReferenciaCruzada } from '../../../../../types';

export interface ReferencesTabProps {
  referenciasSalida: ReferenciaCruzada[];
  referenciasEntrada: ReferenciaCruzada[];
}

export function ReferencesTab({ referenciasSalida, referenciasEntrada }: ReferencesTabProps) {
  return (
    <div style={{ background: '#ECEEF2', padding: '24px 28px', minHeight: 'calc(100vh - 200px)' }}>
      <div style={{ display: 'flex', gap: 20, maxWidth: 820, margin: '0 auto', flexWrap: 'wrap' }}>
        <div style={{ flex: 1, minWidth: 280 }}>
          <h3 style={{ fontSize: 14, fontWeight: 600, color: C.azul1, marginBottom: 12 }}>
            <Ic d={ICON_PATHS.arrowRight} s={14} c={C.azul1} /> Referencia a
          </h3>
          {!referenciasSalida || referenciasSalida.length === 0 ? (
            <div style={{ padding: '24px 0', textAlign: 'center', color: C.textMut, fontSize: 13 }}>
              Sin referencias salientes
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {referenciasSalida.map((r) => (
                <Link
                  key={r.id}
                  to={`/documento/${r.documentoDestino?.codigo}`}
                  style={{
                    textDecoration: 'none',
                    background: '#EFF6FF',
                    borderRadius: 8,
                    padding: '8px 12px',
                    display: 'block',
                    transition: 'all 0.15s',
                  }}
                >
                  <span
                    style={{
                      fontFamily: 'monospace',
                      fontSize: 12,
                      fontWeight: 700,
                      color: DOC_COLORS.h2,
                    }}
                  >
                    {r.documentoDestino?.codigo}
                  </span>
                  <div style={{ fontSize: 13, color: C.text, marginTop: 2 }}>
                    {r.documentoDestino?.titulo}
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
        <div style={{ flex: 1, minWidth: 280 }}>
          <h3 style={{ fontSize: 14, fontWeight: 600, color: C.azul1, marginBottom: 12 }}>
            <Ic d={ICON_PATHS.link} s={14} c={C.azul1} /> Referenciado por
          </h3>
          {!referenciasEntrada || referenciasEntrada.length === 0 ? (
            <div style={{ padding: '24px 0', textAlign: 'center', color: C.textMut, fontSize: 13 }}>
              Sin referencias entrantes
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {referenciasEntrada.map((r) => (
                <Link
                  key={r.id}
                  to={`/documento/${r.documentoOrigen?.codigo}`}
                  style={{
                    textDecoration: 'none',
                    background: '#EFF6FF',
                    borderRadius: 8,
                    padding: '8px 12px',
                    display: 'block',
                    transition: 'all 0.15s',
                  }}
                >
                  <span
                    style={{
                      fontFamily: 'monospace',
                      fontSize: 12,
                      fontWeight: 700,
                      color: DOC_COLORS.h2,
                    }}
                  >
                    {r.documentoOrigen?.codigo}
                  </span>
                  <div style={{ fontSize: 13, color: C.text, marginTop: 2 }}>
                    {r.documentoOrigen?.titulo}
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
